import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconInclinometrySizeS from './IconInclinometry_size_s';

const props: CreateIconArguments = {
  l: IconInclinometrySizeS,
  m: IconInclinometrySizeS,
  s: IconInclinometrySizeS,
  xs: IconInclinometrySizeS,
  name: 'IconInclinometry',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
